import { consumeContext } from "@/lib/consume/context"
import { GeolocationContext } from "@/lib/geolocation/context"

export const consumeGeolocation = consumeContext({
  Context: GeolocationContext,
  provideTo: `geolocation`,
})
